import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Panel,
  PanelBody,
  Form,
  IconSet,
  Column,
  Section,
  Grid
} from '@govhhs/govhhs-design-system-react';
import { RouterLink } from '@spm/core-ui';
import { Authentication } from '@spm/universal-access';
import PATHS from '../../../paths';
import translations from './NFMFASessionMessages';
import { ID } from '../constants';

/**
 * The NFAccountOptions handles the rendering of the NFAccountOptions feature.
 *
 * @param intl The API to format dates, numbers and strings.
 * @param history The history.
 *
 * @namespace NFAccountOptions
 * @memberof features.NFAccountOptions/components
 */
export const NFAccountOptions = ({ intl, history }) => {
  useEffect(() => {
    if (
      Authentication.userTypeIs([Authentication.USER_TYPES.STANDARD]) ||
      Authentication.userTypeIs([Authentication.USER_TYPES.LINKED])
    ) {
      history.push(PATHS.NFACCOUNTHOME);
    }
  }, []);

  return (
    <Section primary>
      <Grid className="wds-u-mt--small">
        <Form center fill inverse>
          <Column>
            <p className="wds-u-mv--small">
              <RouterLink inverse to={PATHS.HOME}>
                <IconSet className="wds-u-mr--x-small" decorative name="chevron-left" />
                {intl.formatMessage(translations.NFMFASessionMessages_93)}
              </RouterLink>
            </p>
            <br />
          </Column>
          <Column>
            <div align="left">
              <font size="+3">
                {intl.formatMessage(translations.NFMFASessionMessages_1)}
              </font>
            </div>
            <br />
            <p>{intl.formatMessage(translations.NFMFASessionMessages_2)}</p>
            <br />
            <p>
              <Button
                category="outline"
                data-testid={ID.NFMFASESSION_ACCOUNTOPTIONS_LOGIN_BUTTON_ID}
                onClick={() => {
                  history.push(PATHS.NFLOGIN);
                }}
                size="full"
              >
                {intl.formatMessage(translations.NFMFASessionMessages_5)}
              </Button>
            </p>
            <br />
            <Panel
              ariaLabel={intl.formatMessage(
                translations.NFMFASessionMessages_4
              )}
              bordered
            >
              <PanelBody>
                <p>
                  {intl.formatMessage(translations.NFMFASessionMessages_3)}
                  <RouterLink inverse to={PATHS.NFCREATENCIDACCOUNT}>
                    {intl.formatMessage(translations.NFMFASessionMessages_4)}
                  </RouterLink>
                  <IconSet decorative name="chevron-right" />
                </p>
              </PanelBody>
            </Panel>
          </Column>
        </Form>
      </Grid>
    </Section>
  );
};

NFAccountOptions.propTypes = {
  history: PropTypes.object.isRequired,
  intl: intlShape.isRequired
};
export default withRouter(injectIntl(NFAccountOptions));
